export default __webpack_public_path__ + "static/media/T.4f69669f.png";